// @flow strict
import {customAlphabet} from 'nanoid'
import englishLowercase from 'nanoid-dictionary/lowercase'

type Generator = () => string

export default function getIDGenerator(size: number = 10): Generator {
  return customAlphabet(englishLowercase, size)
}
